/**
 * Generate UPI app-specific deep links from a base upi_intent URI.
 * Reference: https://test-api.tripayco.com hosted checkout uses the same pattern.
 */

import type { UPIApp } from '../types/checkout';

export interface UPIAppLink {
  app: UPIApp;
  label: string;
  scheme: string;
  url: string;
}

/**
 * Build deep links for common UPI apps from a base upi:// intent URI.
 * The base URI typically looks like: upi://pay?pa=...&pn=...&am=...&tr=...&cu=INR
 */
export function buildUPIAppLinks(baseUPIIntent: string): UPIAppLink[] {
  if (!baseUPIIntent) return [];

  // Extract the query part from upi://pay?...
  const queryPart = baseUPIIntent.replace(/^upi:\/\/pay\??/i, '');
  if (!queryPart) return [];

  return [
    {
      app: 'phonepe',
      label: 'PhonePe',
      scheme: 'phonepe',
      url: `phonepe://pay?${queryPart}`,
    },
    {
      app: 'googlepay',
      label: 'Google Pay',
      scheme: 'tez',
      url: `tez://upi/pay?${queryPart}`,
    },
    {
      app: 'paytm',
      label: 'Paytm',
      scheme: 'paytmmp',
      url: `paytmmp://pay?${queryPart}`,
    },
    {
      app: 'upi',
      label: 'UPI',
      scheme: 'upi',
      url: baseUPIIntent,
    },
  ];
}
